import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import ModernPaymentsPage from '../pages/ModernPaymentsPage';
import ContractorFinancialHub from '../pages/ContractorFinancialHub';
import MerchantPaymentsPage from '../pages/MerchantPaymentsPage';
import { Container, Typography, CircularProgress, Button } from '@mui/material';

const PaymentsRouter = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  // Show loading state while authentication is being checked
  if (isLoading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>Loading...</Typography>
      </Container>
    );
  }

  // Redirect to login if not authenticated (though this should be handled by ProtectedRoute)
  if (!isAuthenticated || !user) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="h6" color="error">
          Access denied. Please log in to view this page.
        </Typography>
      </Container>
    );
  }

  // Route to appropriate page based on user role
  switch (user.role?.toLowerCase()) {
    case 'contractor':
      // Contractors see their earnings and payment history with enhanced financial hub
      return <ContractorFinancialHub />;
    
    case 'merchant':
      // Merchants see their material order payments and earnings
      return <MerchantPaymentsPage />;
    
    case 'admin':
      // Redirect admins to their admin dashboard
      return (
        <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Admin Access Restricted
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Use the Admin Dashboard to manage platform payments and financial oversight.
          </Typography>
          <Button 
            variant="contained" 
            href="/admin/dashboard"
            sx={{ mt: 2 }}
          >
            Go to Admin Dashboard
          </Button>
        </Container>
      );
    
    case 'client':
    case 'verifier':
    case 'professional_verifier':
    case 'quality_inspector':
    default:
      // Others see the payment sending interface
      return <ModernPaymentsPage />;
  }
};

export default PaymentsRouter;
